import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const translationMembershipApi = generateNomenApi(`/translation/translation-membership`);

export const translationMembershipOptions = generateNomenOptions('translation-membership', translationMembershipApi);
